import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Button, Popover } from '@workboard/wobo-ui';
import Add from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';
import { ReadOnlyComp } from '../../../read-license';

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 32px;

  h1 {
    font-size: 24px;
    line-height: 40px;
    letter-spacing: 0.15px;
    font-weight: 700;
    flex-grow: 1;
    margin: 0;
  }

  ${Button} {
    height: 40px;
    border-radius: 4px;
    align-items: center;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    font-weight: 700;

    svg {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
`;

export const TeamLandingHeader = (): JSX.Element => {
  const { t } = useTranslation();
  const [isRead, setIsRead] = useState(false);
  const [open, setOpen] = useState(false);
  const anchor = useRef();
  const readFlag = window.wbConfig.userLicenseType == '0';
  const isUserReadOnly = window.wbConfig.userLicenseOrgFeatureFlag ?? false;
  const canCreateDynamicTeam = window.wbConfig.canCreateDynamicTeam ?? true;
  const [rolEvent, setRolEvent] = useState(null);
  const page = new URL(window.location.href).pathname;

  const handleAddTeam = () => {
    if (readFlag && isUserReadOnly) {
      setIsRead(true);
      setRolEvent({
        rolEventTarget: 'Team Landing Page',
        rolEventType: 'Click',
        rolEventSource: page,
      });
    } else {
      window.wb_track('TEAM_CREATE_CLICKED', {
        UserId: window.uData.user_id,
        OrgId: window.uData.org_id,
        Timestamp: Date.now(),
        Source: 'Teams List',
      });

      if (open) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }
  };

  const handleButtonClose = async () => {
    setIsRead(false);
    setRolEvent(null);
  };

  return (
    <HeaderWrapper>
      <h1>{t('Teams')}</h1>
      {readFlag && isUserReadOnly ? (
        <div>
          <Button
            arrow={false}
            variant="primary"
            size="small"
            aria-label={t('Add new team')}
            ref={anchor}
            startIcon={<Add />}
            onClick={handleAddTeam}
            removeActions
            removeClose
            style={{ backgroundColor: '#b7d6e5', color: '#ffffff' }}
          >
            {t('New Team')}
          </Button>
          {isRead && (
            <Popover
              removeActions
              removeClose
              targetRef={anchor}
              arrow={false}
              placement="bottom-start"
              open={isRead}
              className="readOnlyOver"
              onDismiss={() => setIsRead(false)}
              content={
                <ReadOnlyComp
                  handleClose={handleButtonClose}
                  rolEvent={rolEvent}
                />
              }
            />
          )}
        </div>
      ) : null}
      {!(readFlag && isUserReadOnly) && !canCreateDynamicTeam && <div />}
      {!(readFlag && isUserReadOnly) && canCreateDynamicTeam && (
        <div>
          <Button
            variant="primary"
            size="small"
            className="newTeamButton"
            aria-label={t('Add new team')}
            onClick={handleAddTeam}
          >
            <Add /> {t('New Team')}
          </Button>
        </div>
      )}
    </HeaderWrapper>
  );
};

export default TeamLandingHeader;
